












import Vue from 'vue'
import { CentralIconElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'CentralIconEl',

  props: {
    templateItemData: {
      type: Object as () => CentralIconElInterface,
      required: true
    }
  },

  data: () => ({
    iconWidth: 77,
    iconHeight: 77
  }),

  mounted () {
    this.resolveIconSize()
  },

  methods: {
    resolveIconSize () {
      switch (this.$props.templateItemData.size) {
        case 'small':
          this.iconHeight = 24
          this.iconWidth = 24
          break
        case 'medium':
          this.iconHeight = 77
          this.iconWidth = 77
          break
        case 'large':
          this.iconHeight = 96
          this.iconWidth = 96
          break
      }
    }
  }
})
